import { Button, Col, Form, Row } from 'ant-design-vue'

/**
 * @Date: 2020-05-26 17:55
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
// TODO
const searchTwo = {
  name: 'search-two',
  render () {
    // console.log('$slots ===> ', this.$slots)
    return (
      <div class="table-page-search-wrapper">
        <Form layout="inline">
          <Row gutter={48}>
            {this.renderCols()}
            <Col span={24}>
              {
                Object.keys(this.$slots).length > 0 ? (
                  this.$slots.action
                ) : (
                  <span className="table-page-search-submitButtons" style="float:right;overflow: hidden;">
                    <Button type="primary" onClick={this.searchHandler}>查询</Button>
                    <Button style="margin-left: 8px" onClick={this.resetHandler}>重置</Button>
                  </span>
                )
              }
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}
export default searchTwo
